<p [ngClass]="'text-' + align">
    @if (isSearchResults) {
        {{ 'global.labels.no_items_found' | translate }}
    } @else {
        {{ label || ('global.labels.no_data' | translate) }}
    }
</p>
